<template>
    <div
        v-loading="loading"
        class="mak-makina-fotos my-8"
        :class="[!list.length ? 'justify-center' : 'justify-start']"
    >
        <v-carousel
            v-if="list.length"
            v-model="carousel"
            hide-delimiters
            height="300"
        >
            <v-carousel-item
                v-for="(f, ind) in list"
                :key="ind"
            >
                <v-img
                    :src="f.src"
                    max-height="300"
                    contain
                    class="grey lighten-3"
                />
            </v-carousel-item>
        </v-carousel>

        <v-alert
            v-if="!list.length"
            color="blue-grey"
            dark
            class="mt-4"
        >
            Henüz hiç fotoğraf eklenmedi.
        </v-alert>
    </div>
</template>

<script>
    import { getApiUrl } from '@/common/configs';

    export default {
        name: 'mak-makina-fotos',
        props: {
            makinaId: {type: [Number, String], required: true},
        },
        data() {
            return {
                loading: false,
                list: [],
                host: getApiUrl(),
                carousel: 0,
            };
        },
        methods: {
            fetch() {
                this.loading = true;
                this.list = [];
                this.$requests.MakinaFoto
                    .getMakinaFotos(this.makinaId)
                    .then((data) => {
                        if (!data?.length) {
                            return;
                        }
                        this.list = data.map((d) => {
                            d.src = `${this.host}${d.yolu}${d.dosya_adi}`;
                            return d;
                        });
                    })
                    .catch((e) => {
                        console.error('error on fetching fotos', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.fetch();
        },
    };
</script>

<style lang="scss" scoped>

    .mak-makina-fotos {
        max-width: 530px;
            .v-img {
            //display: flex;
            //justify-content: center;
            //align-items: center;
            //height: 180px;
            //width: 240px;
            //margin-right: 15px;
        }
    }
</style>
